import { AfterViewInit, Component, ViewContainerRef } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';
import { WsTooltipService } from './ws-tooltip.service';

@Component({
  selector: 'ws-tooltip-root',
  template: '',
})
export class WsTooltipRootComponent implements AfterViewInit {
  constructor(
    private viewContainerRef: ViewContainerRef,
    private tooltipService: WsTooltipService,
    private dialog: MatDialog,
    private overlayContainer: OverlayContainer
  ) {}

  ngAfterViewInit(): void {
    this.tooltipService.registerViewContainerRef(this.viewContainerRef);
    this.tooltipService.init(this.dialog, this.overlayContainer);
  }
}
